// @ts-nocheck: converted from JS

import Edit from '@/components/Studies/Requests/Edit/Edit';

export default Edit;
